import { useMemo } from 'react';
import { matchesNetworkTestDial } from './lib/networkTestDial';
import usePhoneState from './usePhoneState';

function useVisibleCallList() {
  const { callList, networkTestInProgress } = usePhoneState();

  // filters out calls during a network test
  return useMemo(
    () =>
      callList.filter(
        (call) =>
          !(
            networkTestInProgress && matchesNetworkTestDial(call.remoteIdentity)
          ),
      ),
    [callList, networkTestInProgress],
  );
}

export default useVisibleCallList;
